import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var QueueService = /*#__PURE__*/function () {
  function QueueService() {
    _classCallCheck(this, QueueService);

    this.items = [];
  }

  _createClass(QueueService, [{
    key: "enqueue",
    value: function enqueue(item) {
      this.items.push(item);
    }
  }, {
    key: "dequeue",
    value: function dequeue() {
      if (this.isEmpty()) {
        return null;
      }

      return this.items.shift();
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.items.length === 0;
    }
  }]);

  return QueueService;
}();

export default QueueService;